import { useState, useMemo } from 'react';

import { ChevronRight } from 'lucide-react';
import Image from 'next/image';

import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';

export default function ProductActivity({ data }) {
  const showProductActivity = useMemo(() => {
    return (
      data?.discountPriceMaxDiscount ||
      data?.productWelfareList?.length > 0 ||
      data?.productRecord?.returnCouponDesc?.length > 0
    );
  }, [data]);

  const discount = useMemo(() => {
    if (data?.discountPriceMaxDiscount) {
      return data.discountPriceMaxDiscount * 100;
    }
    return 0;
  }, [data?.discountPriceMaxDiscount]);

  const productWelfareList = useMemo(() => {
    const arr = [discount, data?.productRecord?.returnCouponDesc?.length || 0];
    const index = arr.filter((item) => item || item > 0).length;

    if (index === 2) {
      return [];
    }

    return (data?.productWelfareList || []).slice(0, 3 - index);
  }, [discount, data?.productRecord?.returnCouponDesc, data?.productWelfareList]);

  const ItemStyled = ({ children }) => {
    return (
      <div className="h-[18px] leading-[16px] text-[12px] text-[#ea494a] mr-[6px] mt-[1px] px-[6px] rounded-[2px] border border-solid border-[#ea494a] truncate">
        {children}
      </div>
    );
  };

  const [open, setOpen] = useState(false);

  const mapType = {
    purchase_money: '采购晶',
    point: '积分',
  };

  return showProductActivity ? (
    <>
      <section
        className="px-4 py-3 flex items-center justify-between shadow-[inset_0_-1px_rgba(236,236,236,0.5)]"
        onClick={() => setOpen(true)}
      >
        <h2 className="text-[14px]">优惠活动</h2>
        <div className="flex flex-wrap items-center w-[180px] text-[12px]">
          {discount ? <ItemStyled>{discount / 10}折</ItemStyled> : <></>}
          {productWelfareList.map((item, index) => {
            return <ItemStyled key={index}>{item.activityName}</ItemStyled>;
          })}
          {data?.productRecord?.returnCouponDesc?.length > 0 && <ItemStyled>满额返券</ItemStyled>}
        </div>
        <ChevronRight className="w-4 h-4 shrink-0 text-muted-foreground" />
      </section>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="p-0 rounded-t-[8px] max-h-[80vh] overflow-hidden">
          <SheetHeader className="p-4">
            <SheetTitle>优惠活动</SheetTitle>
          </SheetHeader>
          <div className="p-[16px]">
            {discount ? (
              <div className="mb-[16px]">
                <div className="flex items-center">
                  <Image
                    src="https://static.szlcsc.com/ecp/assets/app/product-detail/icon.png"
                    alt=""
                    width={18}
                    height={18}
                  ></Image>
                  <span className="ml-[10px]">{discount / 10}</span>
                </div>
              </div>
            ) : (
              <></>
            )}
            {data?.productWelfareList?.map((item) => (
              <>
                <div className="mb-[16px]">
                  <div className="flex items-center">
                    <Image
                      src="https://static.szlcsc.com/ecp/assets/app/product-detail/icon.png"
                      alt=""
                      width={18}
                      height={18}
                    ></Image>
                    <span className="ml-[10px]">{item.activityName}</span>
                  </div>
                  <div className="ml-[28px] mt-[10px] text-[#334463] text-[14px]">
                    {item?.thresholdRedisVOList?.map((list, index) => (
                      <span key={index}>
                        <span>{item.rebateDimension === 'multiple_order_amount' ? '累计' : '单笔'}</span>
                        {item.rebateDimension === 'single_order_amount' && <span>每</span>}
                        {/* 以多笔订单金额 */}
                        {item.rebateDimension === 'multiple_order_amount' && (
                          <span>{list.limitPartakeCount !== null && list.limitPartakeCount === 1 ? '' : '每'}</span>
                        )}
                        满{list.orderAmount}：送
                        <span className="text-[#ea494a]">
                          {list.rebateAmount}
                          {mapType[item.rebateType]}
                        </span>
                      </span>
                    ))}
                  </div>
                </div>
              </>
            ))}
            {data?.productRecord?.returnCouponDesc?.length > 0 && (
              <>
                <div className="mb-[16px]">
                  <div className="flex items-center">
                    <Image
                      src="https://static.szlcsc.com/ecp/assets/app/product-detail/icon.png"
                      alt=""
                      width={18}
                      height={18}
                    ></Image>
                    <span className="ml-[10px]">满额返券</span>
                  </div>
                  <div className="ml-[28px] mt-[10px] text-[#334463] text-[14px]">
                    {data?.productRecord?.returnCouponDesc[0].message}
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="p-[16px]">
            <button
              className="w-[100%] h-[44px] text-white m-auto rounded-[8px] bg-[#0093e6]"
              onClick={() => setOpen(false)}
            >
              确定
            </button>
          </div>
        </SheetContent>
      </Sheet>
    </>
  ) : (
    <></>
  );
}
